import Icon from '../components/Icon.vue'

Icon.register({
  sun: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 160C203.1 160 160 203.1 160 256S203.1 352 256 352 352 308.9 352 256 308.9 160 256 160zM502.4 240.5L407.7 193.2 441.2 92.8C445.7 79.2 432.8 66.3 419.3 70.9L318.9 104.4 271.5 9.6C265.1-3.2 246.9-3.2 240.5 9.6L193.2 104.3 92.7 70.8C79.1 66.3 66.2 79.2 70.8 92.7L104.3 193.1 9.6 240.5C-3.2 246.9-3.2 265.1 9.6 271.5L104.3 318.8 70.8 419.3C66.3 432.9 79.2 445.8 92.7 441.2L193.1 407.7 240.4 502.4C246.8 515.2 265 515.2 271.4 502.4L318.7 407.7 419.1 441.2C432.7 445.7 445.6 432.8 441 419.3L407.5 318.9 502.2 271.6C515.2 265.1 515.2 246.9 502.4 240.5zM346.5 346.5C296.6 396.4 215.4 396.4 165.5 346.5 115.6 296.6 115.6 215.4 165.5 165.5 215.4 115.6 296.6 115.6 346.5 165.5 396.4 215.4 396.4 296.6 346.5 346.5z'
      }
    ]
  }
})
